import { render } from "./AudioWolofElement.vue?vue&type=template&id=0564f5f0&scoped=true"
import script from "./AudioWolofElement.vue?vue&type=script&lang=js"
export * from "./AudioWolofElement.vue?vue&type=script&lang=js"

import "./AudioWolofElement.vue?vue&type=style&index=0&id=0564f5f0&scoped=true&lang=css"

import exportComponent from "../../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0564f5f0"]])

export default __exports__